import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import MiniCartItem from '../MiniCartItem';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';

// Styles
import styles from './index.module.sass';

// Variables
const country = process.env.REACT_APP_COUNTRY;

export default function MiniCart({
  orderData,
  history,
  match,
  setOpenMiniCart,
  openMiniCart,
  getCookie,
  webservice,
  setOrderData,
  setSessionMessage,
  agotado,
}) {
  const { t } = useTranslation('minicart');
  const { detallePedido = [], totales = {}, situacionCierreMensaje = '' } = orderData;
  const [haveMessage, setHaveMessage] = useState([]);

  const setMessages = useCallback(() => {
    const orderDetail = orderData?.detallePedido || [];
    let messages = [];
    for (let i = 0; i < orderDetail.length; i++) {
      const { status = '' } = orderDetail[i] || {};
      if (status) messages.push(status);
    }
    setHaveMessage(messages);
  }, [orderData]);

  useEffect(() => {
    setMessages();
  }, [setMessages]);

  return (
    <Slide direction='left' in={openMiniCart} timeout={500} mountOnEnter unmountOnExit>
      <div className={`${styles.miniCart}`}>
        <div className={styles.content}>
          <div className={styles.title}>
            <span>{t('title')}:</span>
            <i
              className={`material-icons-outlined ${styles.closeIcon}`}
              onClick={() => setOpenMiniCart(false)}>
              close
            </i>
          </div>
          <div className={styles.orderNum}>
            {t('order')} #{getCookie('folioPedido')}
          </div>
          {(situacionCierreMensaje && (
            <div className={styles.warningMessaje}>{situacionCierreMensaje}</div>
          )) ||
            (haveMessage.length > 0 && <div className={styles.warningMessaje}>{t('warning')}</div>)}
          {detallePedido.length > 0 && (
            <div className={styles.tableContainer}>
              {detallePedido.map((val, key) => {
                return (
                  <MiniCartItem
                    key={key}
                    item={val}
                    getCookie={getCookie}
                    webservice={webservice}
                    setOrderData={setOrderData}
                    setSessionMessage={setSessionMessage}
                    setHaveMessage={setHaveMessage}
                    haveMessage={haveMessage}
                  />
                );
              })}
              {/* <CreateItems /> */}
            </div>
          )}
        </div>

        <div className={styles.miniCartFooter}>
          <div className={styles.subtotal}>
            <div className={styles.subTex}>{t('subtotal')}:</div>
            <div className={styles.subNum}>${totales?.subtotal || ''}</div>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              variant='contained'
              size='large'
              color='primary'
              className={styles.button}
              onClick={() => {
                setOpenMiniCart(false);
                history.push(`${match.path}/shoppingcart`);
              }}>
              {t('continue')} <i className={`material-icons ${styles.buttonIcon}`}>trending_flat</i>
            </Button>
          </div>
          {orderData.situacionCierre === 'LISTO' && (
            <div className={styles.finishOrder}>
              <span
                className={styles.finishText}
                onClick={() => {
                  setOpenMiniCart(false);
                  history.push('/cart/selectaddress');
                }}>
                {t('checkoutAndPay')}
              </span>
            </div>
          )}
        </div>
      </div>
    </Slide>
  );
}
